import { useCallback, useReducer, useState } from 'react';
import { State, Actions } from './update-to-event-button';

const popoverReducer = (state: State, action: Actions): State => {
    switch (action.type) {
        case 'CLOSE':
            return { isPopoverOpen: false, isConfirmModalOpen: false };
        case 'SHOW_SELECT_ENTITIES_POPOVER':
            return { isPopoverOpen: true, isConfirmModalOpen: false };
        case 'SHOW_CONFIRM_UPDATE_MODAL':
            return { isPopoverOpen: false, isConfirmModalOpen: true };
        default:
            return state;
    }
};

const initialPopoverState: State = {
    isPopoverOpen: false,
    isConfirmModalOpen: false,
};

export function useUpdateToEventState({
    initialEventId,
    disableInitialBootstrap = false,
}: {
    initialEventId: number | undefined;
    disableInitialBootstrap?: boolean;
}) {
    const [popoverState, popoverDispatch] = useReducer(popoverReducer, initialPopoverState);
    const [bootstrapEventId, setBootstrapEventIdInternal] = useState<number | undefined>(initialEventId);
    const [bootstrapActive, setBootstrapActive] = useState(!disableInitialBootstrap);

    const setEventId = useCallback((id: number | undefined) => {
        setBootstrapEventIdInternal(id);
    }, []);

    const enableBootstrap = useCallback(() => {
        if (!bootstrapActive) {
            setBootstrapActive(true);
        }
    }, [bootstrapActive]);

    return {
        bootstrapEventId,
        bootstrapActive,
        setEventId,
        enableBootstrap,
        popoverState,
        popoverDispatch,
    };
}
